import { RQ } from 'utils';

export default {
  async init() {
    const res = await RQ.mall.get('/api/app/skin/tester/report', { type:1 }, {enterprise: '', loading: false});
    if (res.code === 0) {
      this.reportData = res;
      if(this.reportData.data) {
        this.nursingContrastData = JSON.parse(this.reportData.data.report);
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/module/app/nursingContrast/action.js